import React from "react";
import { Button } from "reactstrap";
import Ink from "react-ink";

import "./style.css";

function CustomButton(props) {
  return (
    <div
      style={props.btnConatinerSyle}
      className={`button-container ${props.buttonContainerClasses}`}
    >
      <Button
        type={props.type}
        disabled={props.disabled}
        color="primary"
        style={props.buttonStyle}
        className={`custom-button ${props.buttonClasses}`}
        onClick={props.onClick}
      >
        {props.buttonText}
        {!props.disabled && <Ink />}
      </Button>
    </div>
  );
}

CustomButton.defaultProps = {
  buttonText: "",
  btnConatinerSyle: {},
  buttonStyle: {},
  buttonContainerClasses: "",
  buttonClasses: "",
  onClick: function() {},
  disabled: false,
  type: "button"
};

export default CustomButton;
